import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { useStore } from "vuex";
import { watch, computed } from "vue";
import OptionSelector from "@/components/UI/OptionSelector.vue";
import OptionSelectorWrapper from "@/components/UI/OptionSelectorWrapper.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EdgeFinish',
  setup(__props) {

const i18n = window.measurementSelectorVariables.i18n;
const kpsSettings = window.measurementSelectorVariables;
const store = useStore();

const exportShape = computed(() => store.getters.exportShape);
const activeEdgeFinish = computed(() => store.getters.activeEdgeFinish);
const getEdgeFinishMethods = computed(() => store.getters.getEdgeFinishMethods);
const getDefaultEdgeFinish = computed(() => store.getters.getDefaultEdgeFinish);
const usePriceFromServer = computed(() => store.getters.usePriceFromServer);

watch(activeEdgeFinish, async (newValue: string, oldValue: string) => {
	if (!usePriceFromServer.value) {
		return;
	}
	if (newValue !== oldValue) {
		store.dispatch("retrieveDxfDefinitionDebounced");
	}
});

function updateEdgeFinish(e: InputEvent) {
	const target = (e.target as HTMLInputElement);
	store.commit("updateActiveEdgeFinish", target.value);
}

function getBadge(value: string): string {
	if (getDefaultEdgeFinish.value === value && exportShape.value === 'rectangle') {
		return i18n.edgeFinish.meta.free;
	} else if (getDefaultEdgeFinish.value !== value) {
		return i18n.edgeFinish.meta.premium;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OptionSelectorWrapper, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getEdgeFinishMethods.value, ({ value, label }) => {
        return (_openBlock(), _createBlock(OptionSelector, {
          name: "edge-finish",
          key: value,
          isActive: activeEdgeFinish.value === value,
          activeValue: activeEdgeFinish.value,
          value: value,
          image: `${_unref(kpsSettings).assets}/images/${value}-light.png`,
          badge: getBadge(value),
          label: label,
          onInput: updateEdgeFinish
        }, null, 8, ["isActive", "activeValue", "value", "image", "badge", "label"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})